import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ICarouselImage } from 'src/app/interfaces/carousel-image';
import { Subscription as RxSubscription } from 'rxjs';

import { CarouselImageDataSource } from '../../services/carousel-image-data-source';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { ImagesService } from 'src/app/services/images.service';

@Component({
    selector: 'carousel-images-view',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CarouselImagesView implements OnInit, OnDestroy {
  @Input() editable: boolean;
  @Input() DataSource: CarouselImageDataSource;
  public imageUrl: string;

  public leisureUrl = environment.leisureUrl;

  public loading: boolean;
  public role: string;

  public CarouselImages: ICarouselImage[] = [];

  private Subscriptions: RxSubscription[] = [];

  constructor(
    protected dialog: MatDialog,
    private commonFunctionService: CommonFunctionService,
    private imagesService: ImagesService
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (CarouselImages: ICarouselImage[]) =>
          (this.CarouselImages = CarouselImages)
      )
    );
    this.role = this.DataSource.getConfig().role;
    const url = this.commonFunctionService.findApiUrl(this.role);
    this.imageUrl = `${url}/${this.role}/`;
    // setTimeout is digest cycle hack/fix (loading triggered outside component)
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading: boolean) =>
        setTimeout(() => (this.loading = loading))
      )
    );
  }

  public edit() {
    this.DataSource.viewList(this.role);
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  public getImageUrl(image) {
    return this.imagesService.getImageUrl(image);
  }
}
